import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {WebOnboardingService} from '../../_services/web-onboarding.service';

@Component({
  selector: 'app-phone',
  templateUrl: './phone.component.html',
  styleUrls: ['./phone.component.css'],
})
export class PhoneComponent implements OnInit, OnDestroy {
  @Input() prefillPhone: string | null = null;
  @Output() submitted = new EventEmitter<{verificationId: string}>();

  form = new FormGroup({
    phone: new FormControl('', [
      Validators.required,
      Validators.pattern(/^(\+?54)?(9)?[1-9]\d{9}$/),
    ]),
  });

  ngOnInit(): void {
    if (this.prefillPhone) {
      this.form.patchValue({phone: this.prefillPhone});
    }
  }

  loading = false;
  errorMessage = '';

  private destroy$ = new Subject<void>();

  constructor(private onboardingService: WebOnboardingService) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.loading = true;
    this.errorMessage = '';
    const phone = this.form.value.phone!;

    this.onboardingService
      .sendSms(phone)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.loading = false;
          this.submitted.emit({verificationId: response.id || response.verificationId || ''});
        },
        error: (err) => {
          this.loading = false;
          const body = err.error;
          if (body?.errors?.length) {
            this.errorMessage = body.errors.map((e: any) => e.message).filter(Boolean).join('\n');
          } else if (body?.message) {
            this.errorMessage = body.message;
          } else {
            this.errorMessage = 'Error al enviar el SMS. Intentá nuevamente.';
          }
        },
      });
  }
}
